/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/purse-1214301': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 7h-1V6a3 3 0 00-3-3H5a3 3 0 00-3 3v12a3 3 0 003 3h14a3 3 0 003-3v-8a3 3 0 00-3-3zM5 5h10a1 1 0 011 1v1H5a1 1 0 010-2zm15 10h-1a1 1 0 010-2h1zm0-4h-1a3 3 0 000 6h1v1a1 1 0 01-1 1H5a1 1 0 01-1-1V8.83A3 3 0 005 9h14a1 1 0 011 1z"/>'
  }
})
